<template>
	<pui-datatable
		:modelName="modelName"
		:customizeActionAvailability="customizeActionAvailability"
		:modelColumnDefs="modelColumnDefs"
		:parentModel="parentModel"
		:externalFilter="externalFilter"
		:parentModelName="parentModelName"
		:readOnly="readOnly"
		:showMasterDetailFilterListBtn="true"
		:showMasterDetailFilterBtn="true"
		:showMasterDetailSortBtn="true"
		:showMasterDetailConfBtn="true"
	></pui-datatable>
</template>

<script>

import PuiGridDetailMixin from 'pui9-mixins/PuiGridDetailMixin';
import { STATUS_DRAFT_ID } from '../../constants/imofalforms/ImoFalFormsConstants';

export default {
	name: 'imofalform7-grid',
	mixins: [PuiGridDetailMixin],
	components: {},
	data() {
		return {
			modelName: 'imofalform7',
			modelColumnDefs: {
				indarrivaldeparture: {
					render: (data) => {
						if (data === '1') {
							return this.$t('grid.imofalform6.isarrival');
						} else if (data === '2') {
							return this.$t('grid.imofalform6.isdeparture');
						} else {
							return '';
						}
					}
				}
			}
		};
	},
	methods: {
		extendFilter(filter) {
			if (this.parentModelName === 'imofalform7menu') {
				filter.rules.push({ field: 'imofalformid', op: 'eq', data: this.parentModel.imofalformid });
			}
		},
		customizeActionAvailability(actionId, parentModel) {
			if (actionId === 'puiImportAction' || actionId === 'puiExportAction') {
				return parentModel.statusid === STATUS_DRAFT_ID;
			}
		}
	}
};
</script>
